import * as Sentry from '@sentry/react'
import normalizeError from './normalizeError'

/**
 * 代理把trycatch中的console.error,生产环境上报Sentry
 * 如果一个trycatch希望上报就需要在catch中的console.error首个参数为catchError
 */

export default () => {
    const originalConsoleError = console.error

    // 可以忽略的字符
    const exclude_message_prefix = 'REJECT_'
    const exclude_message_keywords = ['cancel', 'Cancel', 'canceled', '关闭', '关闭操作', '取消', '已取消', window.PROJECT_CONFIG.ERROR_NEED_CHECK_ADMIN_CODE, window.PROJECT_CONFIG.ERROR_NO_LOGIN_CODE]

    console.error = function (...args) {
        if (args?.[0] === 'catchError') {
            const err = normalizeError(args?.[1])
            const msg = err?.message

            if (msg?.startsWith(exclude_message_prefix) || exclude_message_keywords.includes(msg)) {
                return
            }

            Sentry.setExtra('extra', {
                errorInfo: JSON.stringify(args)
            })

            Sentry.captureException(err || new Error('catchError'), {
                tags: {
                    type: 'catchError'
                }
            })
        }

        originalConsoleError.apply(console, args)
    }
}
